<template>
  <div
    class="elevation-4 ma-2 pointer round-4"
    @click="$emit('on-click',category)"
  >
    <div class="grey lighten-4 text-center">
      <v-img
        grey
        :src="category.thumb_nail"
        width="200"
        min-width="200"
        height="200"
        min-height="200"
      >
      </v-img>
    </div>
    <div class="pa-3 text-left">
      <v-icon>{{ category.icon }}</v-icon>
      <span class="text-decoration-underlinex primary--text cat-item-text pl-2"
        >{{ category.name }}
      </span>
    </div>
    <v-divider></v-divider>
    <div class="pr-2 pl-2 d-flex justify-space-between fs-14">
      <div calss="text-left">Businesses:</div>
      <div class="text-right grey--text">
        <b>{{
          comma(
            belongings[category.id]
              ? belongings[category.id][0].count_business_id
              : 0
          )
        }}</b>
      </div>
    </div>
    <v-divider></v-divider>
    <div class="pr-2 pl-2 d-flex justify-space-between fs-14">
      <div calss="text-left">Sub Categories:</div>
      <div class="text-right grey--text">
        <b>{{
          sub_categories[category.id]
            ? sub_categories[category.id][0].count_category_id
            : 0
        }}</b>
      </div>
    </div>
    <v-divider></v-divider>
    <div class="pr-2 pl-2 d-flex justify-space-between fs-14">
      <div calss="text-left">Is A Top Category:</div>
      <div class="text-right">
        <b class="success--text" v-if="parseInt(category.is_top_category) == 1"
          >YES</b
        >
        <b class="grey--text" v-else>NO</b>
      </div>
    </div>
    <v-divider></v-divider>
  </div>
</template>

<script>
import Utils from "../lib/Utils"
export default {
  name: "CategoryTile",
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    category: {
      type: Object,
      default: () => {
        return null;
      },
    },
    belongings: {
      type: Object,
      default: () => {
        return null;
      },
    },
    sub_categories: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  methods: {
    comma(v) {
      if (v < 10) {
        v = "0" + v.toString();
      }
      return Utils.add_commas(v);
    },
  },
};
</script>